/* Product header time in Silicon Valley, translated consistently per storefront locale. */
(function () {
 'use strict';
 const zone = 'America/Los_Angeles';
 const locales = {en:'en-US',es:'es-ES',ja:'ja-JP',ko:'ko-KR',zh:'zh-CN',fr:'fr-FR',de:'de-DE',pt:'pt-BR',it:'it-IT',ar:'ar',fil:'fil-PH',tl:'fil-PH'};
 const names = {
 en:'Silicon Valley Time',es:'hora de Silicon Valley',ja:'シリコンバレー時間',ko:'실리콘밸리 시간',
 zh:'硅谷时间',fr:'heure de la Silicon Valley',de:'Silicon-Valley-Zeit',pt:'Horário do Vale do Silício',
 it:'ora della Silicon Valley',ar:'توقيت وادي السيليكون',fil:'Oras sa Silicon Valley',tl:'Oras sa Silicon Valley'
 };
 function update(){
  const root=document.querySelector('.template-product .date-time-container, .logo-container .date-time-container, .date-time-container');
  if(!root)return;
  const dateNode=root.querySelector('.date'),timeNode=root.querySelector('.time');
  if(!dateNode||!timeNode)return;
  const language=(document.documentElement.lang||'en').toLowerCase().split('-')[0];
  const locale=locales[language]||'en-US',now=new Date();
  const use12=!['fr','de','pt','it'].includes(language);
  const dateOptions={timeZone:zone,year:'numeric',month:['ar','es','fr','de','pt','it'].includes(language)?'long':'numeric',day:'numeric'};
  const timeOptions={timeZone:zone,hour:'numeric',minute:'2-digit',hour12:use12};
  try {
   let d=new Intl.DateTimeFormat(locale,dateOptions).format(now);
   if(language==='fil'||language==='tl'){
    const p=new Intl.DateTimeFormat('en-US',{timeZone:zone,year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now);
    const v=k=>p.find(x=>x.type===k)?.value||'';
    d=['Ene','Peb','Mar','Abr','May','Hun','Hul','Ago','Set','Okt','Nob','Dis'][Number(v('month'))-1]+' '+v('day')+', '+v('year');
   }
   const tm=new Intl.DateTimeFormat(locale,timeOptions).format(now);
   const label=names[language]||names.en;
   if(dateNode.textContent!==d)dateNode.textContent=d;
   const rendered=language==='en' ? tm+' SV' : tm+' — '+label;
   if(timeNode.textContent!==rendered)timeNode.textContent=rendered;
   root.setAttribute('lang',locale);
   root.setAttribute('dir',language==='ar'?'rtl':'ltr');
   root.style.visibility='visible';root.style.opacity='1';
  } catch(e) {}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update);else update();
 setInterval(update,15000);
 document.addEventListener('shopify:section:load',update);
 window.addEventListener('pageshow',update);
})();
